import { dateStringFormat, useEmployeeQuery } from '@alice-financial/alice-sdk'

export const useOffboardDate = () => {
  const { data: employeeData } = useEmployeeQuery()
  const employee = employeeData?.employee
  if (employee === undefined) return undefined
  const offboardingDate = employee?.employer.offboardingDate
  if (!offboardingDate) return null

  return dateStringFormat.dateFromDateString(offboardingDate)
}
